<template>
  <div class="agenda-page">
    <section class="top-section">
      <div class="top-section__content section-content">
        <div class="top-section__left">
          <div class="top-section__title">
            See the full event schedule and explore resources.
          </div>
          <div class="top-section__date">June 9, 2021</div>
          <div class="top-section__thanks">
            Thank you for joining us. We've got an amazing schedule of events
            we're excited to experience with you!
          </div>
        </div>
        <div class="top-section__right">
          <img src="@/assets/agenda_lede_image.png" alt="power one" />
        </div>
      </div>
    </section>

    <section class="agenda-section">
      <div class="agenda-section__content section-content">
        <v-row>
          <v-col sm="12" md="2">
            <div class="agenda-section__title">Agenda</div>
          </v-col>
          <v-col sm="12" md="10">
            <AgendaDay
              v-for="agendaDay in agendaDays"
              :key="agendaDay.date"
              :date="agendaDay.date"
              :day="agendaDay.day"
              :items="agendaDay.items"
            />
          </v-col>
        </v-row>
      </div>
    </section>
  </div>
</template>

<script>
import AgendaDay from "@/components/AgendaDay";

export default {
  name: "AgendaPage",
  metaInfo: {
    titleTemplate: "%s - Agenda"
  },
  components: { AgendaDay },
  data() {
    return {
      agendaDays: [
        {
          date: "June 9",
          day: "Wednesday",
          items: [
            {
              time:
                "<span class='time-wrap'>10:30 –</span> <span class='time-wrap'>11:30 a.m. CT</span>",
              topic: `<b>Partner Summit Live Session</b><br>
                <ul>
                <li><b>Session Welcome</b></li>
                <li><b>Remarks by ALSAC/St. Jude President & CEO, Rick Shadyac</b></li>
                <li><b>Featured St. Jude Partner Speaker:</b> Charlie Cole, CEO, FTD</li>
                <li><b>St. Jude Mission Moment:</b> Special guests,  Maelin-Kate & Megan, St. Jude patient family</li>
                <li><b>St. Jude Hospital Presentation:</b> Dr. Sara Federico, MD</li>
                </ul>`
            },
            {
              time:
                "<span class='time-wrap'>11:35 a.m. –</span> <span class='time-wrap'>12:00 p.m. CT</span>",
              topic: `<b>Optional Live Virtual Networking Session</b><br>`
            }
          ]
        },
        {
          date: "",
          day: "Breakout Sessions available on demand",
          items: [
            {
              topic: `<b>One Click Wonder: The E-commerce Solution</b>`
            },
            {
              topic: `<b>PIVOT!! Utilizing Digital to Make Key Changes</b>`
            },
            {
              topic: `<b>Expanding Your Partnership Through Employee Engagement</b>`
            },
            {
              topic: `<b>Join Us! The Mission is Great: Launching Your St. Jude Partnership</b>`
            },
            {
              topic: `<b>It’s All Fun and Games</b>`
            },
            {
              topic: `<b>Be A Hero for St. Jude</b>`
            },
            {
              topic: `<b>Create, Promote, Success: Product Promotion Best Practices</b>`
            },
            {
              topic: `<b>Walk it out… For a Great Cause</b>`
            },
            {
              topic: `<b>Purposeful Storytelling</b>`
            },
            {
              topic: `<b>Answering the Call: ALSAC and Corporate Social Responsibility and Justice</b>`
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.top-section {
  background-color: #f5f5f5;
  padding: 90px 75px 100px 120px;

  &__content {
    display: flex;
    align-items: center;
  }

  &__left {
    flex: 1;
    margin-right: 60px;
  }

  &__right {
    > img {
      max-width: 457px;
    }
  }

  &__title {
    font-weight: 800;
    font-size: 64px;
    line-height: 1.14;
    color: $primary;
  }
  &__date {
    font-weight: bold;
    font-size: 43px;
    line-height: 50px;
    margin: 35px 0 45px;
    color: $stjude-red;
  }
  &__thanks {
    font-size: 18px;
    line-height: 24px;
    color: black;
  }
}

.agenda-section {
  padding: 40px 120px 10px;
  background: url(~@/assets/agenda_bg.jpg);
  background-blend-mode: multiply, normal;
  mix-blend-mode: darken;
  background-position: center;
  background-size: cover;

  &__title {
    font-weight: bold;
    font-size: 43px;
    line-height: 50px;
    color: white;
  }
}

@media screen and (max-width: 960px) {
  .top-section {
    padding: 35px 20px 50px;
    &__content {
      flex-direction: column-reverse;
    }

    &__left {
      margin-right: 0;
    }

    &__title {
      font-size: 43px;
      line-height: 44px;
      padding-right: 10px;
      margin: 20px 0 10px;
    }

    &__date {
      margin: 10px 0;
    }

    &__right {
      img {
        width: 100%;
      }
    }
  }

  .agenda-section {
    padding: 30px 20px;
    .row {
      flex-direction: column;
    }
  }
}
</style>
